module.exports = __webpack_public_path__ + "static/media/creditCard.b3fc7fad.png";